import { HttpClient } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { ItemPreferencesWebService } from './item-preferences.web-service';

@NgModule()
export class AdminWebServicesModule {
  public static forRoot(): ModuleWithProviders<AdminWebServicesModule> {
    return {
      ngModule: AdminWebServicesModule,
      providers: [
        {
          provide: ItemPreferencesWebService,
          useFactory: (httpClient: HttpClient) => new ItemPreferencesWebService(httpClient),
          deps: [HttpClient],
        },
      ],
    };
  }
}
